import { render, staticRenderFns } from "./ContractInstructionsTab.vue?vue&type=template&id=54091d9a&"
import script from "./ContractInstructionsTab.vue?vue&type=script&lang=js&"
export * from "./ContractInstructionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports